// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* App root */
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

/* ── Header ─────────────────────────────────────────────── */
.app-header {
  background: rgba(0, 0, 0, 0.3);
  color: white;
  padding: 12px 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.header-title-block h1 {
  font-size: 1.6rem;
  margin-bottom: 2px;
  white-space: nowrap;
}

.header-title-block p {
  font-size: 0.88rem;
  opacity: 0.85;
  margin: 0;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* ── Olympian / Paralympian toggle ─────────────────────── */
.athlete-type-toggle {
  display: inline-flex;
  border-radius: 30px;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.6);
}

.athlete-type-btn {
  padding: 6px 16px;
  background: transparent;
  color: white;
  border: none;
  font-size: 0.88rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
  white-space: nowrap;
}

.athlete-type-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.athlete-type-btn.active.olympic {
  background: #FFD700;
  color: #333;
  font-weight: 700;
}

.athlete-type-btn.active.paralympic {
  background: #9333ea;
  color: white;
  font-weight: 700;
}

/* Shift overall app gradient when in Paralympic mode */
.app--paralympic {
  background: linear-gradient(135deg, #4f46e5 0%, #7e22ce 100%);
}

/* Loading and error states */
.loading-container,
.error-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  color: white;
}

.error-container {
  flex-direction: column;
}

.error-container p {
  margin-top: 10px;
  font-size: 1.1rem;
}

/* Main layout container */
.app-container {
  display: flex;
  flex: 1 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  gap: 20px;
}

.app-sidebar {
  width: 350px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.app-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Search bar */
.search-bar {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.search-bar h2 {
  margin-bottom: 15px;
  color: #333;
}

.search-bar form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.search-input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.search-button {
  padding: 10px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
}

.search-button:hover:not(:disabled) {
  background: #5568d3;
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-results {
  margin-top: 15px;
  max-height: 300px;
  overflow-y: auto;
  border-top: 1px solid #eee;
  padding-top: 15px;
}

.search-results h3 {
  color: #333;
  margin-bottom: 10px;
}

.search-results ul {
  list-style: none;
}

.search-results li {
  margin-bottom: 8px;
}

.result-item {
  width: 100%;
  padding: 10px;
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 6px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.95rem;
}

.result-item:hover {
  background: #f0f0f0;
  border-color: #667eea;
}

.athlete-count {
  float: right;
  color: #667eea;
  font-weight: bold;
}

/* 统计面板 */
.stats-panel {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.stats-panel h2 {
  margin-bottom: 15px;
  color: #333;
}

.stats-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
}

.stat-label {
  font-size: 0.9rem;
  opacity: 0.9;
}

.chart-container {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.chart-container h3 {
  color: #333;
  margin-bottom: 15px;
}

/* 地图容器 */
.map-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-container h2 {
  margin-bottom: 10px;
  color: #333;
}

.map-description {
  flex: 1 1;
  min-width: 0;
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 12px;
}

.map-top-n-inline {
  display: inline;
  padding: 1px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  cursor: pointer;
  vertical-align: baseline;
  color: #333;
}

.map-error {
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  color: #c33;
}

.map-error code {
  display: block;
  margin-top: 10px;
  background: white;
  padding: 10px;
  border-radius: 4px;
  text-align: left;
  overflow-x: auto;
}

.info-window-content {
  padding: 10px;
  min-width: 200px;
}

.info-window-content h4 {
  margin-bottom: 8px;
  color: #333;
}

.info-window-content p {
  margin: 5px 0;
  color: #666;
}

.view-details-btn {
  margin-top: 10px;
  width: 100%;
  padding: 8px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.view-details-btn:hover {
  background: #5568d3;
}

/* Modal - 详情弹窗 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}

.modal-close:hover {
  color: #333;
}

.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 25px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin-bottom: 8px;
  font-size: 1.8rem;
}

.athletes-count {
  font-size: 1.1rem;
  opacity: 0.9;
}

.modal-body {
  padding: 25px;
}

.info-section {
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.info-section:last-child {
  border-bottom: none;
}

.info-section h3 {
  color: #333;
  margin-bottom: 12px;
  font-size: 1.1rem;
}

.info-section p {
  color: #666;
  line-height: 1.6;
}

.sports-list {
  list-style: none;
}

.sports-list li {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 6px;
  margin-bottom: 8px;
}

.sport-name {
  font-weight: 500;
  color: #333;
}

.sport-count {
  color: #667eea;
  font-weight: bold;
}

.story-section {
  background: #f0f4ff;
  padding: 15px;
  border-radius: 8px;
}

.story-text {
  color: #333;
  line-height: 1.8;
  white-space: pre-wrap;
  word-break: break-word;
}

.story-wordcount {
  font-size: 0.78rem;
  font-weight: 400;
  color: #999;
  margin-left: 6px;
}

/* ── Geographic Profile list in modal ──────────────────── */
.geo-profile-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.geo-profile-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #f9f9f9;
  border-radius: 6px;
  font-size: 0.92rem;
}

.geo-label {
  color: #666;
  font-weight: 500;
}

.geo-value {
  color: #333;
  font-weight: 600;
}


.modal-footer {
  padding: 20px 25px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.modal-close-btn {
  padding: 10px 20px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s;
}

.modal-close-btn:hover {
  background: #5568d3;
}

/* ── Mode tabs (inline in header) ──────────────────────── */
.mode-tabs {
  display: flex;
  gap: 4px;
}

.mode-tab {
  padding: 6px 14px;
  border: 2px solid rgba(255,255,255,0.5);
  border-radius: 24px;
  background: transparent;
  color: white;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.mode-tab:hover { background: rgba(255,255,255,0.15); }
.mode-tab.active { background: white; color: #667eea; border-color: white; font-weight: 600; }

/* ── Stats row (4 panels above map) ────────────────────── */
.stats-row {
  display: flex;
  gap: 12px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 14px 20px 0;
}

.stats-panel-card {
  flex: 1 1;
  background: white;
  border-radius: 12px;
  padding: 12px 16px 4px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  min-width: 0;
}

.stats-panel-card h3 {
  font-size: 0.9rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.stat-items {
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.stat-num {
  font-size: 1.5rem;
  font-weight: 700;
  color: #667eea;
}

.stat-lbl {
  font-size: 0.72rem;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.top-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.top-list-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 0.8rem;
}

.top-rank {
  color: #bbb;
  font-size: 0.72rem;
  width: 14px;
  text-align: right;
  flex-shrink: 0;
}

.top-name {
  flex: 1 1;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-count {
  color: #667eea;
  font-weight: 600;
  flex-shrink: 0;
}

/* ── Stats panel chart header (title + range selector) ─── */
.stats-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.stats-card-header h3 {
  font-size: 0.9rem;
  font-weight: 700;
  color: #333;
  margin: 0;
  border: none;
  padding: 0;
}

.range-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: #666;
  flex-shrink: 0;
}

.range-selector select {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 0.78rem;
  cursor: pointer;
  background: white;
}

/* ── Summary card in header ─────────────────────────────── */
.summary-card {
  display: flex;
  gap: 20px;
  align-items: center;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}

.summary-num {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FFD700;
  line-height: 1;
}

.summary-lbl {
  font-size: 0.65rem;
  color: rgba(255,255,255,0.75);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* ── Search results modal ───────────────────────────────── */
.search-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease;
}

.search-modal {
  background: white;
  border-radius: 16px;
  padding: 28px 28px 20px;
  max-width: 480px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.2s ease;
  box-shadow: 0 20px 60px rgba(0,0,0,0.25);
}

.search-modal h3 {
  font-size: 1.15rem;
  color: #333;
  margin-bottom: 10px;
  padding-right: 24px;
}

.search-modal-note {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #f8f8ff;
  border-left: 3px solid #667eea;
  border-radius: 0 6px 6px 0;
}

.search-modal-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.search-modal-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 0.9rem;
  text-align: left;
}

.search-modal-item:hover {
  background: #f0f0ff;
  border-color: #667eea;
}

.smi-location { color: #333; }
.smi-count {
  color: #667eea;
  font-weight: 700;
  font-size: 0.85rem;
  flex-shrink: 0;
  margin-left: 12px;
}

.search-modal-empty {
  color: #999;
  font-size: 0.9rem;
  text-align: center;
  padding: 20px 0;
}

.search-modal-close-btn {
  width: 100%;
  padding: 10px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
}

.search-modal-close-btn:hover { background: #5568d3; }

/* ── Search modal: sport patterns section ───────────────── */
.smodal-patterns {
  margin-bottom: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eee;
}

.smodal-explain {
  font-size: 0.82rem;
  color: #666;
  line-height: 1.55;
  margin-bottom: 14px;
  padding: 10px 12px;
  background: #f8f8ff;
  border-left: 3px solid #667eea;
  border-radius: 0 6px 6px 0;
}

.smodal-pattern-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.smodal-pattern-item {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px 12px;
}

.spi-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 5px;
}

.spi-sport {
  font-weight: 600;
  font-size: 0.9rem;
  color: #222;
}

.spi-ratio {
  font-size: 0.8rem;
  font-weight: 700;
  color: #667eea;
  flex-shrink: 0;
  margin-left: 8px;
}

.spi-bar-wrap {
  background: #e8e8f4;
  border-radius: 4px;
  height: 6px;
  margin-bottom: 5px;
  overflow: hidden;
}

.spi-bar {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.spi-detail {
  font-size: 0.76rem;
  color: #888;
}

/* ── Search modal: hometowns results section ─────────────── */
.smodal-results h3 {
  margin-bottom: 8px;
}

.smodal-results-note {
  font-size: 0.82rem;
  color: #666;
  line-height: 1.5;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f8f8ff;
  border-left: 3px solid #22c55e;
  border-radius: 0 6px 6px 0;
}

/* ── Modal close (X) button ─────────────────────────────── */
.modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  background: none;
  border: none;
  font-size: 1.1rem;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.15s;
}

.modal-close:hover { color: #333; }

/* ── Sport Concentration Panel ─────────────────────────── */
.concentration-panel {
  background: white;
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.concentration-panel h3 { color: #333; margin-bottom: 8px; font-size: 1rem; }

.concentration-note {
  font-size: 0.82rem;
  color: #777;
  line-height: 1.5;
  margin-bottom: 12px;
  font-style: italic;
}

.concentration-loading,
.concentration-error,
.concentration-empty { font-size: 0.9rem; color: #888; padding: 6px 0; }
.concentration-error { color: #c33; }

.concentration-list { list-style: none; display: flex; flex-direction: column; gap: 10px; }

.concentration-item { display: flex; flex-direction: column; gap: 3px; }

.concentration-sport { font-weight: 600; color: #333; font-size: 0.92rem; }

.concentration-bar-wrap {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.concentration-bar {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 3px;
  transition: width 0.4s ease;
}

.concentration-stats { display: flex; justify-content: space-between; font-size: 0.78rem; }
.concentration-ratio { color: #667eea; font-weight: 600; }
.concentration-counts { color: #999; }

/* ── Explore Mode ──────────────────────────────────────── */
.explore-mode {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  gap: 0;
}

/* ── Explore tabs ── */
.explore-tab-bar {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
}

.explore-tab {
  padding: 7px 18px;
  border: 2px solid rgba(255,255,255,0.4);
  border-radius: 24px;
  background: transparent;
  color: white;
  font-size: 0.87rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}
.explore-tab:hover { background: rgba(255,255,255,0.15); }
.explore-tab.active { background: white; color: #667eea; border-color: white; font-weight: 700; }

/* Sport tab: row layout wrapper */
.explore-sport-content {
  display: flex;
  gap: 20px;
  flex: 1 1;
  min-height: 0;
}

/* Search tab panel */
.explore-search-content {
  background: white;
  border-radius: 12px;
  padding: 28px 32px;
  max-width: 640px;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  align-self: flex-start;
}
.explore-search-content h2 { font-size: 1.1rem; color: #333; margin-bottom: 16px; }

.explore-left-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
  flex-shrink: 0;
}

.explore-sidebar {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex: 1 1;
  min-height: 500px;
  overflow-y: auto;
}

.explore-search-box {
  background: white;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.explore-search-box h3 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #444;
  margin: 0 0 10px;
}

.explore-sidebar h2 { color: #333; }

.explore-description {
  font-size: 0.85rem;
  color: #777;
  line-height: 1.5;
  font-style: italic;
}

.explore-label { font-size: 0.9rem; font-weight: 600; color: #444; }

.explore-select {
  width: 100%;
  padding: 9px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: pointer;
}

.explore-select:focus { outline: none; border-color: #667eea; }

.explore-loading, .explore-error, .explore-empty { font-size: 0.88rem; color: #888; }
.explore-error { color: #c33; }

.explore-summary { font-size: 0.9rem; color: #444; }
.explore-summary h4 { margin: 8px 0 4px; color: #333; }

.explore-top-list { padding-left: 18px; font-size: 0.88rem; color: #555; }
.explore-top-list li { margin-bottom: 3px; }
.explore-count { color: #667eea; font-weight: 600; }
.explore-city-link { background: none; border: none; padding: 0; cursor: pointer; color: #667eea; text-decoration: underline; font-size: inherit; font-family: inherit; }

.explore-heatmap-desc {
  background: #f8f8ff;
  border-left: 3px solid #667eea;
  border-radius: 0 6px 6px 0;
  padding: 10px 12px;
  font-size: 0.82rem;
  color: #444;
  line-height: 1.55;
}

.explore-heatmap-desc h4 {
  font-size: 0.8rem;
  color: #667eea;
  margin-bottom: 5px;
}

.explore-heatmap-desc p { margin: 0; }

.explore-legend { border-top: 1px solid #eee; padding-top: 12px; }
.explore-legend h4 { font-size: 0.88rem; color: #555; margin-bottom: 8px; }
.legend-row { display: flex; align-items: center; gap: 8px; font-size: 0.82rem; color: #666; margin-bottom: 4px; }

.legend-dot {
  border-radius: 50%;
  background: #dc2626;
  flex-shrink: 0;
}
.legend-dot.large { width: 18px; height: 18px; opacity: 0.9; }
.legend-dot.small { width: 8px; height: 8px; opacity: 0.4; }
.legend-dot.state { width: 12px; height: 12px; background: #f97316; opacity: 0.7; border: 1.5px dashed #9a3412; }

.explore-coverage { font-size: 0.88rem; color: #444; margin-bottom: 10px; line-height: 1.5; }
.explore-state-note { color: #f97316; }
.explore-hidden-note { color: #999; }
.explore-top-list li.state-level { color: #f97316; }

.explore-map { flex: 1 1; min-width: 0; }

.explore-map-area {
  position: relative;
}

/* ── Map observation box (map view) ── */
.map-observation-box {
  display: flex;
  align-items: baseline;
  gap: 8px;
  background: rgba(255,255,255,0.92);
  border-left: 3px solid #667eea;
  border-radius: 0 8px 8px 0;
  padding: 8px 14px;
  font-size: 0.85rem;
  color: #333;
  line-height: 1.5;
  flex: 1 1;
  min-width: 200px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
}

.map-observation-box--facts {
  border-left-color: #22c55e;
}

.map-obs-label {
  font-weight: 700;
  color: #667eea;
  white-space: nowrap;
  flex-shrink: 0;
}

.map-observation-box--facts .map-obs-label {
  color: #16a34a;
}

.map-obs-text {
  flex: 1 1;
}

.map-obs-wordcount {
  color: #aaa;
  font-size: 0.75rem;
  white-space: nowrap;
  flex-shrink: 0;
}

.explore-obs-below { margin-top: 10px; }

.explore-year-chart {
  margin-top: 10px;
  background: white;
  border-radius: 8px;
  padding: 14px 16px 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.explore-year-chart h4 {
  font-size: 0.88rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 10px;
}

.map-obs-refresh {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0 2px;
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.map-obs-refresh:hover:not(:disabled) { opacity: 1; }
.map-obs-refresh:disabled { cursor: default; opacity: 0.35; }

/* ── Cartoon overlay — bottom-left corner of the map canvas ── */
.explore-animation-overlay {
  position: absolute;
  /* .map-container has 20px padding; align with the inner map canvas edge */
  bottom: 20px;
  left: 20px;
  width: 160px;
  height: 130px;
  z-index: 10;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 3px 14px rgba(0,0,0,0.35);
}

.explore-animation-svg {
  width: 100%;
  height: 100%;
  line-height: 0;
}

.explore-animation-svg svg {
  display: block;
  width: 100%;
  height: 100%;
}

.explore-animation-loading {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.6);
}

.explore-animation-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #dde;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ── Sport Leaders filter row ── */
.map-description-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.map-top-n-inline {
  font-size: 0.9rem;
  padding: 1px 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  cursor: pointer;
}

.map-filter-toggle {
  display: flex;
  gap: 0;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f3f4f6;
}

.filter-opt {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  color: #555;
  transition: background 0.15s, color 0.15s;
  -webkit-user-select: none;
          user-select: none;
}

.filter-opt input[type="radio"] {
  display: none;
}

.filter-opt.active {
  background: #1d4ed8;
  color: white;
}

.filter-opt:not(.active):hover {
  background: #e5e7eb;
}

/* ── Map wrapper for hub legend overlay ── */
.map-google-wrap {
  position: relative;
}

/* ── Sport Hubs legend ── */
.hub-legend {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 10px 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  max-width: 200px;
  font-size: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column;
}

.hub-legend-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.hub-legend-title {
  font-size: 0.72rem;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.hub-legend-toggle {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.6rem;
  color: #9ca3af;
  padding: 2px 4px;
  line-height: 1;
}
.hub-legend-toggle:hover { color: #374151; }

.hub-legend-body {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  max-height: 360px;
}

.hub-legend-section {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.hub-legend-section-title {
  font-size: 0.67rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 2px;
}

.hub-legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.hub-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1.5px solid rgba(255,255,255,0.8);
  box-shadow: 0 0 0 1px rgba(0,0,0,0.10);
}

.hub-legend-name {
  font-size: 0.74rem;
  color: #374151;
  line-height: 1.2;
}

.hub-legend-scale {
  border-top: 1px solid #e5e7eb;
  padding-top: 8px;
}

.hub-scale-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 4px;
}

.hub-scale-dot {
  border-radius: 50%;
  background: #6b7280;
  flex-shrink: 0;
  display: inline-block;
}

.hub-scale-label {
  font-size: 0.67rem;
  color: #9ca3af;
  margin-left: 2px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.explore-map-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.explore-map-placeholder p {
  background: rgba(0,0,0,0.72);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow: 0 2px 12px rgba(0,0,0,0.3);
}

/* ── Compare Mode ──────────────────────────────────────── */
.compare-mode {
  flex: 1 1;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.compare-header h2 { color: white; margin-bottom: 6px; }
.compare-description { color: rgba(255,255,255,0.85); font-size: 0.95rem; }

.compare-pickers {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.compare-vs {
  color: white;
  font-size: 1.4rem;
  font-weight: 700;
  padding-top: 48px;
  flex-shrink: 0;
}

.region-picker {
  flex: 1 1;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.region-picker h3 { color: #333; }

.region-type-toggle { display: flex; gap: 8px; }

.region-type-toggle button {
  flex: 1 1;
  padding: 7px;
  border: 2px solid #ddd;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.region-type-toggle button.active {
  border-color: #667eea;
  background: #667eea;
  color: white;
}

.compare-input {
  width: 100%;
  padding: 9px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.95rem;
}

.compare-input:focus { outline: none; border-color: #667eea; }

.compare-select {
  width: 100%;
  padding: 9px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: pointer;
}

.compare-actions { display: flex; justify-content: center; }

.compare-btn {
  padding: 12px 40px;
  background: white;
  color: #667eea;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.compare-btn:hover:not(:disabled) { background: #f0f0ff; transform: translateY(-1px); }
.compare-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.compare-error { color: #fca5a5; text-align: center; font-size: 0.95rem; }

.compare-results {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.compare-totals { display: flex; gap: 16px; }

.compare-total-card {
  flex: 1 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
}

.compare-total-label { font-size: 0.9rem; opacity: 0.85; margin-bottom: 4px; }
.compare-total-num { font-size: 1.6rem; font-weight: 700; }

.compare-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 4px;
}

.compare-chart-title { color: #333; font-size: 1.1rem; margin: 0; }
.compare-chart-note { color: #888; font-size: 0.82rem; margin-bottom: 12px; }

.compare-top-n {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #555;
}

.compare-top-n select {
  padding: 3px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 0.85rem;
  background: white;
  cursor: pointer;
}

.compare-tables { display: flex; gap: 20px; }

.compare-table-wrap { flex: 1 1; }
.compare-table-wrap h4 { color: #333; margin-bottom: 8px; }

.compare-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}

.compare-table th, .compare-table td {
  padding: 7px 10px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.compare-table th { color: #666; font-weight: 600; background: #f9f9f9; }
.compare-table td { color: #333; }

/* ── 响应式设计 */
@media (max-width: 1024px) {
  .app-container {
    flex-direction: column;
  }

  .app-sidebar {
    width: 100%;
  }

  .app-header h1 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .app-header h1 {
    font-size: 1.5rem;
  }

  .app-header p {
    font-size: 1rem;
  }

  .modal-content {
    max-width: 90vw;
    max-height: 90vh;
  }

  .search-results {
    max-height: 200px;
  }
}

/* ══════════════════════════════════════════════════════════
   Agent QA chat component
   ══════════════════════════════════════════════════════════ */
.agent-qa {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  overflow: hidden;
  flex: 1 1;
  min-height: 520px;
}

.agent-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 18px 24px 14px;
  color: white;
}

.agent-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.agent-header h2 { font-size: 1.2rem; margin-bottom: 4px; }

.agent-desc { font-size: 0.83rem; opacity: 0.85; line-height: 1.4; }

.agent-clear-btn {
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 0.8rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s;
}
.agent-clear-btn:hover { background: rgba(255,255,255,0.3); }

/* Scrollable conversation area */
.agent-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

/* Suggested questions */
.agent-suggestions { display: flex; flex-direction: column; gap: 10px; padding: 12px 0; }
.agent-suggestions-label { font-size: 0.85rem; color: #888; font-weight: 500; }
.agent-suggestions-grid { display: flex; flex-direction: column; gap: 8px; }

.agent-suggestion-btn {
  background: #f0f0fd;
  border: 1px solid #d0d0f5;
  border-radius: 8px;
  padding: 10px 14px;
  text-align: left;
  font-size: 0.88rem;
  color: #4c4ce0;
  cursor: pointer;
  transition: background 0.15s;
  font-family: inherit;
}
.agent-suggestion-btn:hover { background: #e3e3fa; }

/* Message rows */
.agent-msg {
  display: flex;
  flex-direction: column;
  max-width: 85%;
}
.agent-msg--user { align-self: flex-end; align-items: flex-end; }
.agent-msg--agent { align-self: flex-start; align-items: flex-start; max-width: 92%; }

/* Bubbles */
.agent-bubble {
  border-radius: 12px;
  padding: 10px 14px;
  line-height: 1.55;
  font-size: 0.9rem;
}
.agent-msg--user .agent-bubble {
  background: #667eea;
  color: white;
  border-bottom-right-radius: 4px;
}
.agent-msg--agent .agent-bubble {
  background: #f5f5f5;
  color: #333;
  border-bottom-left-radius: 4px;
  white-space: pre-wrap;
}
.agent-bubble--loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-style: italic;
}

/* Spinner */
.agent-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #ddd;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: agent-spin 0.8s linear infinite;
  flex-shrink: 0;
}
@keyframes agent-spin { to { transform: rotate(360deg); } }

/* Bubble footer (sources + copy) */
.agent-bubble-footer {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
}

.agent-sources { font-size: 0.75rem; color: #888; line-height: 1.4; }
.agent-sources-label { font-weight: 600; color: #999; }

.agent-copy-btn {
  background: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.75rem;
  color: #666;
  cursor: pointer;
  align-self: flex-start;
  font-family: inherit;
}
.agent-copy-btn:hover { background: #f0f0f0; }

.agent-ts { font-size: 0.72rem; color: #bbb; margin-top: 3px; }

/* Error row */
.agent-error-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #fff3f3;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  font-size: 0.88rem;
}
.agent-error-text { color: #dc2626; flex: 1 1; }
.agent-retry-btn {
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 0.82rem;
  cursor: pointer;
  font-family: inherit;
}
.agent-retry-btn:hover { background: #b91c1c; }

/* Input form */
.agent-form {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #eee;
  background: white;
}

.agent-input {
  flex: 1 1;
  padding: 9px 14px;
  border: 1px solid #ddd;
  border-radius: 24px;
  font-size: 0.9rem;
  outline: none;
  font-family: inherit;
}
.agent-input:focus { border-color: #667eea; }
.agent-input:disabled { background: #f5f5f5; }

.agent-send-btn {
  background: #667eea;
  color: white;
  border: none;
  border-radius: 24px;
  padding: 9px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
  font-family: inherit;
}

/* ── Sport Finder ────────────────────────────────────────── */
.sport-finder-card-wrap {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 0;
}

.sport-finder-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
}

.sport-finder-subtitle {
  font-size: 0.85rem;
  color: #6b7280;
  margin-bottom: 14px;
}

.sport-finder-inputs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.sport-finder-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 140px;
}

.sport-finder-field span {
  font-size: 0.78rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.sport-finder-field input {
  padding: 7px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #111827;
  background: #f9fafb;
  transition: border-color 0.15s;
  outline: none;
}

.sport-finder-field input:focus {
  border-color: #667eea;
  background: white;
}

.sport-finder-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 22px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: inherit;
}

.sport-finder-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sport-finder-btn:not(:disabled):hover {
  opacity: 0.88;
}

.sport-finder-error {
  margin-top: 10px;
  color: #dc2626;
  font-size: 0.85rem;
}

.sport-finder-results {
  margin-top: 16px;
}

.sport-finder-results h4 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 10px;
}

.sport-finder-cards {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.sport-finder-card {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f0f4ff, #faf5ff);
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  min-width: 160px;
  flex: 1 1 160px;
}

.sport-finder-rank {
  font-size: 0.75rem;
  font-weight: 700;
  color: #764ba2;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sport-finder-sport {
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
}

.sport-finder-freq {
  font-size: 0.78rem;
  color: #6b7280;
}
.agent-send-btn:hover:not(:disabled) { background: #5a6fd6; }
.agent-send-btn:disabled { background: #ccc; cursor: not-allowed; }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA,8DAA8D;AAC9D;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,6DAA6D;AAC/D;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kBAAkB,kCAAkC,EAAE;AACtD,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE7F,6DAA6D;AAC7D;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gBAAgB,WAAW,EAAE;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,gCAAgC,mBAAmB,EAAE;;AAErD,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,qBAAqB,WAAW,EAAE;;AAElC,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA,0BAA0B,WAAW,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAE5E;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;uBAEuB,iBAAiB,EAAE,WAAW,EAAE,cAAc,EAAE;AACvE,uBAAuB,WAAW,EAAE;;AAEpC,sBAAsB,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE1F,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvE,uBAAuB,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAE1E;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,uBAAuB,aAAa,EAAE,8BAA8B,EAAE,kBAAkB,EAAE;AAC1F,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,wBAAwB,WAAW,EAAE;;AAErC,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,MAAM;AACR;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA,qBAAqB,kCAAkC,EAAE;AACzD,sBAAsB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEhG,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,sBAAsB;AACxB;AACA,6BAA6B,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB,WAAW,EAAE;;AAEnC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAEnE;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB,aAAa,EAAE,qBAAqB,EAAE;;AAE9D,mDAAmD,kBAAkB,EAAE,WAAW,EAAE;AACpF,iBAAiB,WAAW,EAAE;;AAE9B,mBAAmB,iBAAiB,EAAE,WAAW,EAAE;AACnD,sBAAsB,iBAAiB,EAAE,WAAW,EAAE;;AAEtD,oBAAoB,kBAAkB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AACzE,uBAAuB,kBAAkB,EAAE;AAC3C,iBAAiB,cAAc,EAAE,gBAAgB,EAAE;AACnD,qBAAqB,gBAAgB,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,cAAc,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,oBAAoB,EAAE;;AAExK;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B,SAAS,EAAE;;AAErC,kBAAkB,0BAA0B,EAAE,iBAAiB,EAAE;AACjE,qBAAqB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC1E,cAAc,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAEjH;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;AAC7D,oBAAoB,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE;AAC3D,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,YAAY,EAAE,4BAA4B,EAAE;;AAEhH,oBAAoB,kBAAkB,EAAE,WAAW,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC5F,sBAAsB,cAAc,EAAE;AACtC,uBAAuB,WAAW,EAAE;AACpC,mCAAmC,cAAc,EAAE;;AAEnD,eAAe,SAAO,EAAE,YAAY,EAAE;;AAEtC;EACE,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,wCAAwC,UAAU,EAAE;AACpD,4BAA4B,eAAe,EAAE,aAAa,EAAE;;AAE5D,iEAAiE;AACjE;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,6DAA6D;AAC7D;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB,YAAY,EAAE,kBAAkB,EAAE;AACvD,uBAAuB,6BAA6B,EAAE,kBAAkB,EAAE;;AAE1E;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB,WAAW,EAAE;;AAEjC,sBAAsB,aAAa,EAAE,QAAQ,EAAE;;AAE/C;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uBAAuB,aAAa,EAAE,qBAAqB,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mBAAmB,aAAa,EAAE,uBAAuB,EAAE;;AAE3D;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA,oCAAoC,mBAAmB,EAAE,2BAA2B,EAAE;AACtF,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAEzE;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB,aAAa,EAAE,SAAS,EAAE;;AAE5C;EACE,SAAO;EACP,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,uBAAuB,iBAAiB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AAC7E,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE;;AAE1D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA,uBAAuB,WAAW,EAAE,iBAAiB,EAAE,SAAS,EAAE;AAClE,sBAAsB,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAE5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kBAAkB,aAAa,EAAE,SAAS,EAAE;;AAE5C,sBAAsB,SAAO,EAAE;AAC/B,yBAAyB,WAAW,EAAE,kBAAkB,EAAE;;AAE1D;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,oBAAoB,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACxE,oBAAoB,WAAW,EAAE;;AAEjC,aAAa;AACb;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA,mBAAmB,iBAAiB,EAAE,kBAAkB,EAAE;;AAE1D,cAAc,kBAAkB,EAAE,aAAa,EAAE,gBAAgB,EAAE;;AAEnE;EACE,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;AACA,yBAAyB,iCAAiC,EAAE;;AAE5D,iCAAiC;AACjC;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,wBAAwB;AACxB,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AACxF,2BAA2B,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAC9E,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE3E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;AACtB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA,mBAAmB,oBAAoB,EAAE,qBAAqB,EAAE;AAChE,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE,cAAc,EAAE;;AAErF,YAAY;AACZ;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;AACA,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;;AAE1D,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,iBAAiB,kBAAkB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACpE,uBAAuB,gBAAgB,EAAE,WAAW,EAAE;;AAEtD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,YAAY,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAE9D,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,oBAAoB,cAAc,EAAE,SAAO,EAAE;AAC7C;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;AACA,yBAAyB,mBAAmB,EAAE;;AAE9C,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;AACA,qBAAqB,qBAAqB,EAAE;AAC5C,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,gBAAgB,EAAE,mBAAmB,EAAE","sourcesContent":["/* Global styles */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #f5f5f5;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* App root */\r\n.app {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────────────── */\r\n.app-header {\r\n  background: rgba(0, 0, 0, 0.3);\r\n  color: white;\r\n  padding: 12px 24px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.header-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.header-title-block h1 {\r\n  font-size: 1.6rem;\r\n  margin-bottom: 2px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.header-title-block p {\r\n  font-size: 0.88rem;\r\n  opacity: 0.85;\r\n  margin: 0;\r\n}\r\n\r\n.header-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Olympian / Paralympian toggle ─────────────────────── */\r\n.athlete-type-toggle {\r\n  display: inline-flex;\r\n  border-radius: 30px;\r\n  overflow: hidden;\r\n  border: 2px solid rgba(255, 255, 255, 0.6);\r\n}\r\n\r\n.athlete-type-btn {\r\n  padding: 6px 16px;\r\n  background: transparent;\r\n  color: white;\r\n  border: none;\r\n  font-size: 0.88rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n.athlete-type-btn:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n.athlete-type-btn.active.olympic {\r\n  background: #FFD700;\r\n  color: #333;\r\n  font-weight: 700;\r\n}\r\n\r\n.athlete-type-btn.active.paralympic {\r\n  background: #9333ea;\r\n  color: white;\r\n  font-weight: 700;\r\n}\r\n\r\n/* Shift overall app gradient when in Paralympic mode */\r\n.app--paralympic {\r\n  background: linear-gradient(135deg, #4f46e5 0%, #7e22ce 100%);\r\n}\r\n\r\n/* Loading and error states */\r\n.loading-container,\r\n.error-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  color: white;\r\n}\r\n\r\n.error-container {\r\n  flex-direction: column;\r\n}\r\n\r\n.error-container p {\r\n  margin-top: 10px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n/* Main layout container */\r\n.app-container {\r\n  display: flex;\r\n  flex: 1;\r\n  max-width: 1400px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  gap: 20px;\r\n}\r\n\r\n.app-sidebar {\r\n  width: 350px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.app-main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Search bar */\r\n.search-bar {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.search-bar h2 {\r\n  margin-bottom: 15px;\r\n  color: #333;\r\n}\r\n\r\n.search-bar form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.search-input {\r\n  padding: 10px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #667eea;\r\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.search-button {\r\n  padding: 10px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.search-button:hover:not(:disabled) {\r\n  background: #5568d3;\r\n}\r\n\r\n.search-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.search-results {\r\n  margin-top: 15px;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  border-top: 1px solid #eee;\r\n  padding-top: 15px;\r\n}\r\n\r\n.search-results h3 {\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.search-results ul {\r\n  list-style: none;\r\n}\r\n\r\n.search-results li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.result-item {\r\n  width: 100%;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  border: 1px solid #eee;\r\n  border-radius: 6px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.result-item:hover {\r\n  background: #f0f0f0;\r\n  border-color: #667eea;\r\n}\r\n\r\n.athlete-count {\r\n  float: right;\r\n  color: #667eea;\r\n  font-weight: bold;\r\n}\r\n\r\n/* 统计面板 */\r\n.stats-panel {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.stats-panel h2 {\r\n  margin-bottom: 15px;\r\n  color: #333;\r\n}\r\n\r\n.stats-cards {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.stat-card {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-number {\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 0.9rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.chart-container {\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #eee;\r\n}\r\n\r\n.chart-container h3 {\r\n  color: #333;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n/* 地图容器 */\r\n.map-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.map-container h2 {\r\n  margin-bottom: 10px;\r\n  color: #333;\r\n}\r\n\r\n.map-description {\r\n  flex: 1;\r\n  min-width: 0;\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.map-top-n-inline {\r\n  display: inline;\r\n  padding: 1px 6px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  background: white;\r\n  cursor: pointer;\r\n  vertical-align: baseline;\r\n  color: #333;\r\n}\r\n\r\n.map-error {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  border-radius: 6px;\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: #c33;\r\n}\r\n\r\n.map-error code {\r\n  display: block;\r\n  margin-top: 10px;\r\n  background: white;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  text-align: left;\r\n  overflow-x: auto;\r\n}\r\n\r\n.info-window-content {\r\n  padding: 10px;\r\n  min-width: 200px;\r\n}\r\n\r\n.info-window-content h4 {\r\n  margin-bottom: 8px;\r\n  color: #333;\r\n}\r\n\r\n.info-window-content p {\r\n  margin: 5px 0;\r\n  color: #666;\r\n}\r\n\r\n.view-details-btn {\r\n  margin-top: 10px;\r\n  width: 100%;\r\n  padding: 8px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.view-details-btn:hover {\r\n  background: #5568d3;\r\n}\r\n\r\n/* Modal - 详情弹窗 */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 600px;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.15);\r\n  position: relative;\r\n  animation: slideUp 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.modal-close {\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 15px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #999;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.modal-close:hover {\r\n  color: #333;\r\n}\r\n\r\n.modal-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 25px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin-bottom: 8px;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.athletes-count {\r\n  font-size: 1.1rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.modal-body {\r\n  padding: 25px;\r\n}\r\n\r\n.info-section {\r\n  margin-bottom: 25px;\r\n  padding-bottom: 20px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.info-section:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info-section h3 {\r\n  color: #333;\r\n  margin-bottom: 12px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.info-section p {\r\n  color: #666;\r\n  line-height: 1.6;\r\n}\r\n\r\n.sports-list {\r\n  list-style: none;\r\n}\r\n\r\n.sports-list li {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  border-radius: 6px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sport-name {\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.sport-count {\r\n  color: #667eea;\r\n  font-weight: bold;\r\n}\r\n\r\n.story-section {\r\n  background: #f0f4ff;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.story-text {\r\n  color: #333;\r\n  line-height: 1.8;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n}\r\n\r\n.story-wordcount {\r\n  font-size: 0.78rem;\r\n  font-weight: 400;\r\n  color: #999;\r\n  margin-left: 6px;\r\n}\r\n\r\n/* ── Geographic Profile list in modal ──────────────────── */\r\n.geo-profile-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.geo-profile-list li {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 6px 10px;\r\n  background: #f9f9f9;\r\n  border-radius: 6px;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.geo-label {\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.geo-value {\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.modal-footer {\r\n  padding: 20px 25px;\r\n  border-top: 1px solid #eee;\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.modal-close-btn {\r\n  padding: 10px 20px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 1rem;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.modal-close-btn:hover {\r\n  background: #5568d3;\r\n}\r\n\r\n/* ── Mode tabs (inline in header) ──────────────────────── */\r\n.mode-tabs {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.mode-tab {\r\n  padding: 6px 14px;\r\n  border: 2px solid rgba(255,255,255,0.5);\r\n  border-radius: 24px;\r\n  background: transparent;\r\n  color: white;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.mode-tab:hover { background: rgba(255,255,255,0.15); }\r\n.mode-tab.active { background: white; color: #667eea; border-color: white; font-weight: 600; }\r\n\r\n/* ── Stats row (4 panels above map) ────────────────────── */\r\n.stats-row {\r\n  display: flex;\r\n  gap: 12px;\r\n  max-width: 1400px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 14px 20px 0;\r\n}\r\n\r\n.stats-panel-card {\r\n  flex: 1;\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 12px 16px 4px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  min-width: 0;\r\n}\r\n\r\n.stats-panel-card h3 {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.stat-items {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  padding: 8px 0;\r\n}\r\n\r\n.stat-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 2px;\r\n}\r\n\r\n.stat-num {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  color: #667eea;\r\n}\r\n\r\n.stat-lbl {\r\n  font-size: 0.72rem;\r\n  color: #777;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.top-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.top-list-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 3px 0;\r\n  border-bottom: 1px solid #f5f5f5;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.top-rank {\r\n  color: #bbb;\r\n  font-size: 0.72rem;\r\n  width: 14px;\r\n  text-align: right;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.top-name {\r\n  flex: 1;\r\n  color: #333;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.top-count {\r\n  color: #667eea;\r\n  font-weight: 600;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* ── Stats panel chart header (title + range selector) ─── */\r\n.stats-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 10px;\r\n  padding-bottom: 8px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.stats-card-header h3 {\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  color: #333;\r\n  margin: 0;\r\n  border: none;\r\n  padding: 0;\r\n}\r\n\r\n.range-selector {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.78rem;\r\n  color: #666;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.range-selector select {\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  padding: 2px 6px;\r\n  font-size: 0.78rem;\r\n  cursor: pointer;\r\n  background: white;\r\n}\r\n\r\n/* ── Summary card in header ─────────────────────────────── */\r\n.summary-card {\r\n  display: flex;\r\n  gap: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.summary-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1px;\r\n}\r\n\r\n.summary-num {\r\n  font-size: 1.3rem;\r\n  font-weight: 700;\r\n  color: #FFD700;\r\n  line-height: 1;\r\n}\r\n\r\n.summary-lbl {\r\n  font-size: 0.65rem;\r\n  color: rgba(255,255,255,0.75);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n/* ── Search results modal ───────────────────────────────── */\r\n.search-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: fadeIn 0.15s ease;\r\n}\r\n\r\n.search-modal {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 28px 28px 20px;\r\n  max-width: 480px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  position: relative;\r\n  animation: slideUp 0.2s ease;\r\n  box-shadow: 0 20px 60px rgba(0,0,0,0.25);\r\n}\r\n\r\n.search-modal h3 {\r\n  font-size: 1.15rem;\r\n  color: #333;\r\n  margin-bottom: 10px;\r\n  padding-right: 24px;\r\n}\r\n\r\n.search-modal-note {\r\n  font-size: 0.85rem;\r\n  color: #666;\r\n  line-height: 1.5;\r\n  margin-bottom: 16px;\r\n  padding: 10px 12px;\r\n  background: #f8f8ff;\r\n  border-left: 3px solid #667eea;\r\n  border-radius: 0 6px 6px 0;\r\n}\r\n\r\n.search-modal-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.search-modal-item {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  background: #f9f9f9;\r\n  border: 1px solid #eee;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.15s;\r\n  font-size: 0.9rem;\r\n  text-align: left;\r\n}\r\n\r\n.search-modal-item:hover {\r\n  background: #f0f0ff;\r\n  border-color: #667eea;\r\n}\r\n\r\n.smi-location { color: #333; }\r\n.smi-count {\r\n  color: #667eea;\r\n  font-weight: 700;\r\n  font-size: 0.85rem;\r\n  flex-shrink: 0;\r\n  margin-left: 12px;\r\n}\r\n\r\n.search-modal-empty {\r\n  color: #999;\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n  padding: 20px 0;\r\n}\r\n\r\n.search-modal-close-btn {\r\n  width: 100%;\r\n  padding: 10px;\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.search-modal-close-btn:hover { background: #5568d3; }\r\n\r\n/* ── Search modal: sport patterns section ───────────────── */\r\n.smodal-patterns {\r\n  margin-bottom: 20px;\r\n  padding-bottom: 18px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.smodal-explain {\r\n  font-size: 0.82rem;\r\n  color: #666;\r\n  line-height: 1.55;\r\n  margin-bottom: 14px;\r\n  padding: 10px 12px;\r\n  background: #f8f8ff;\r\n  border-left: 3px solid #667eea;\r\n  border-radius: 0 6px 6px 0;\r\n}\r\n\r\n.smodal-pattern-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.smodal-pattern-item {\r\n  background: #fafafa;\r\n  border: 1px solid #eee;\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n.spi-header {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.spi-sport {\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n  color: #222;\r\n}\r\n\r\n.spi-ratio {\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: #667eea;\r\n  flex-shrink: 0;\r\n  margin-left: 8px;\r\n}\r\n\r\n.spi-bar-wrap {\r\n  background: #e8e8f4;\r\n  border-radius: 4px;\r\n  height: 6px;\r\n  margin-bottom: 5px;\r\n  overflow: hidden;\r\n}\r\n\r\n.spi-bar {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n  border-radius: 4px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.spi-detail {\r\n  font-size: 0.76rem;\r\n  color: #888;\r\n}\r\n\r\n/* ── Search modal: hometowns results section ─────────────── */\r\n.smodal-results h3 {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.smodal-results-note {\r\n  font-size: 0.82rem;\r\n  color: #666;\r\n  line-height: 1.5;\r\n  margin-bottom: 12px;\r\n  padding: 8px 12px;\r\n  background: #f8f8ff;\r\n  border-left: 3px solid #22c55e;\r\n  border-radius: 0 6px 6px 0;\r\n}\r\n\r\n/* ── Modal close (X) button ─────────────────────────────── */\r\n.modal-close {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 14px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.1rem;\r\n  color: #999;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 4px;\r\n  border-radius: 4px;\r\n  transition: color 0.15s;\r\n}\r\n\r\n.modal-close:hover { color: #333; }\r\n\r\n/* ── Sport Concentration Panel ─────────────────────────── */\r\n.concentration-panel {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 18px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n}\r\n\r\n.concentration-panel h3 { color: #333; margin-bottom: 8px; font-size: 1rem; }\r\n\r\n.concentration-note {\r\n  font-size: 0.82rem;\r\n  color: #777;\r\n  line-height: 1.5;\r\n  margin-bottom: 12px;\r\n  font-style: italic;\r\n}\r\n\r\n.concentration-loading,\r\n.concentration-error,\r\n.concentration-empty { font-size: 0.9rem; color: #888; padding: 6px 0; }\r\n.concentration-error { color: #c33; }\r\n\r\n.concentration-list { list-style: none; display: flex; flex-direction: column; gap: 10px; }\r\n\r\n.concentration-item { display: flex; flex-direction: column; gap: 3px; }\r\n\r\n.concentration-sport { font-weight: 600; color: #333; font-size: 0.92rem; }\r\n\r\n.concentration-bar-wrap {\r\n  height: 6px;\r\n  background: #f0f0f0;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n}\r\n\r\n.concentration-bar {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #667eea, #764ba2);\r\n  border-radius: 3px;\r\n  transition: width 0.4s ease;\r\n}\r\n\r\n.concentration-stats { display: flex; justify-content: space-between; font-size: 0.78rem; }\r\n.concentration-ratio { color: #667eea; font-weight: 600; }\r\n.concentration-counts { color: #999; }\r\n\r\n/* ── Explore Mode ──────────────────────────────────────── */\r\n.explore-mode {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  max-width: 1400px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  gap: 0;\r\n}\r\n\r\n/* ── Explore tabs ── */\r\n.explore-tab-bar {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.explore-tab {\r\n  padding: 7px 18px;\r\n  border: 2px solid rgba(255,255,255,0.4);\r\n  border-radius: 24px;\r\n  background: transparent;\r\n  color: white;\r\n  font-size: 0.87rem;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n.explore-tab:hover { background: rgba(255,255,255,0.15); }\r\n.explore-tab.active { background: white; color: #667eea; border-color: white; font-weight: 700; }\r\n\r\n/* Sport tab: row layout wrapper */\r\n.explore-sport-content {\r\n  display: flex;\r\n  gap: 20px;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n/* Search tab panel */\r\n.explore-search-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 28px 32px;\r\n  max-width: 640px;\r\n  width: 100%;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  align-self: flex-start;\r\n}\r\n.explore-search-content h2 { font-size: 1.1rem; color: #333; margin-bottom: 16px; }\r\n\r\n.explore-left-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  width: 300px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.explore-sidebar {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  flex: 1;\r\n  min-height: 500px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.explore-search-box {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 16px 20px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n}\r\n\r\n.explore-search-box h3 {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: #444;\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.explore-sidebar h2 { color: #333; }\r\n\r\n.explore-description {\r\n  font-size: 0.85rem;\r\n  color: #777;\r\n  line-height: 1.5;\r\n  font-style: italic;\r\n}\r\n\r\n.explore-label { font-size: 0.9rem; font-weight: 600; color: #444; }\r\n\r\n.explore-select {\r\n  width: 100%;\r\n  padding: 9px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.explore-select:focus { outline: none; border-color: #667eea; }\r\n\r\n.explore-loading, .explore-error, .explore-empty { font-size: 0.88rem; color: #888; }\r\n.explore-error { color: #c33; }\r\n\r\n.explore-summary { font-size: 0.9rem; color: #444; }\r\n.explore-summary h4 { margin: 8px 0 4px; color: #333; }\r\n\r\n.explore-top-list { padding-left: 18px; font-size: 0.88rem; color: #555; }\r\n.explore-top-list li { margin-bottom: 3px; }\r\n.explore-count { color: #667eea; font-weight: 600; }\r\n.explore-city-link { background: none; border: none; padding: 0; cursor: pointer; color: #667eea; text-decoration: underline; font-size: inherit; font-family: inherit; }\r\n\r\n.explore-heatmap-desc {\r\n  background: #f8f8ff;\r\n  border-left: 3px solid #667eea;\r\n  border-radius: 0 6px 6px 0;\r\n  padding: 10px 12px;\r\n  font-size: 0.82rem;\r\n  color: #444;\r\n  line-height: 1.55;\r\n}\r\n\r\n.explore-heatmap-desc h4 {\r\n  font-size: 0.8rem;\r\n  color: #667eea;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.explore-heatmap-desc p { margin: 0; }\r\n\r\n.explore-legend { border-top: 1px solid #eee; padding-top: 12px; }\r\n.explore-legend h4 { font-size: 0.88rem; color: #555; margin-bottom: 8px; }\r\n.legend-row { display: flex; align-items: center; gap: 8px; font-size: 0.82rem; color: #666; margin-bottom: 4px; }\r\n\r\n.legend-dot {\r\n  border-radius: 50%;\r\n  background: #dc2626;\r\n  flex-shrink: 0;\r\n}\r\n.legend-dot.large { width: 18px; height: 18px; opacity: 0.9; }\r\n.legend-dot.small { width: 8px; height: 8px; opacity: 0.4; }\r\n.legend-dot.state { width: 12px; height: 12px; background: #f97316; opacity: 0.7; border: 1.5px dashed #9a3412; }\r\n\r\n.explore-coverage { font-size: 0.88rem; color: #444; margin-bottom: 10px; line-height: 1.5; }\r\n.explore-state-note { color: #f97316; }\r\n.explore-hidden-note { color: #999; }\r\n.explore-top-list li.state-level { color: #f97316; }\r\n\r\n.explore-map { flex: 1; min-width: 0; }\r\n\r\n.explore-map-area {\r\n  position: relative;\r\n}\r\n\r\n/* ── Map observation box (map view) ── */\r\n.map-observation-box {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  background: rgba(255,255,255,0.92);\r\n  border-left: 3px solid #667eea;\r\n  border-radius: 0 8px 8px 0;\r\n  padding: 8px 14px;\r\n  font-size: 0.85rem;\r\n  color: #333;\r\n  line-height: 1.5;\r\n  flex: 1;\r\n  min-width: 200px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.08);\r\n}\r\n\r\n.map-observation-box--facts {\r\n  border-left-color: #22c55e;\r\n}\r\n\r\n.map-obs-label {\r\n  font-weight: 700;\r\n  color: #667eea;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.map-observation-box--facts .map-obs-label {\r\n  color: #16a34a;\r\n}\r\n\r\n.map-obs-text {\r\n  flex: 1;\r\n}\r\n\r\n.map-obs-wordcount {\r\n  color: #aaa;\r\n  font-size: 0.75rem;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.explore-obs-below { margin-top: 10px; }\r\n\r\n.explore-year-chart {\r\n  margin-top: 10px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 14px 16px 10px;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\r\n}\r\n\r\n.explore-year-chart h4 {\r\n  font-size: 0.88rem;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.map-obs-refresh {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  padding: 0 2px;\r\n  flex-shrink: 0;\r\n  opacity: 0.6;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.map-obs-refresh:hover:not(:disabled) { opacity: 1; }\r\n.map-obs-refresh:disabled { cursor: default; opacity: 0.35; }\r\n\r\n/* ── Cartoon overlay — bottom-left corner of the map canvas ── */\r\n.explore-animation-overlay {\r\n  position: absolute;\r\n  /* .map-container has 20px padding; align with the inner map canvas edge */\r\n  bottom: 20px;\r\n  left: 20px;\r\n  width: 160px;\r\n  height: 130px;\r\n  z-index: 10;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  background: white;\r\n  box-shadow: 0 3px 14px rgba(0,0,0,0.35);\r\n}\r\n\r\n.explore-animation-svg {\r\n  width: 100%;\r\n  height: 100%;\r\n  line-height: 0;\r\n}\r\n\r\n.explore-animation-svg svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.explore-animation-loading {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(255,255,255,0.6);\r\n}\r\n\r\n.explore-animation-spinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid #dde;\r\n  border-top-color: #667eea;\r\n  border-radius: 50%;\r\n  animation: spin 0.8s linear infinite;\r\n}\r\n\r\n/* ── Sport Leaders filter row ── */\r\n.map-description-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.map-top-n-inline {\r\n  font-size: 0.9rem;\r\n  padding: 1px 4px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.map-filter-toggle {\r\n  display: flex;\r\n  gap: 0;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 20px;\r\n  overflow: hidden;\r\n  flex-shrink: 0;\r\n  background: #f3f4f6;\r\n}\r\n\r\n.filter-opt {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 5px 14px;\r\n  font-size: 0.82rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  color: #555;\r\n  transition: background 0.15s, color 0.15s;\r\n  user-select: none;\r\n}\r\n\r\n.filter-opt input[type=\"radio\"] {\r\n  display: none;\r\n}\r\n\r\n.filter-opt.active {\r\n  background: #1d4ed8;\r\n  color: white;\r\n}\r\n\r\n.filter-opt:not(.active):hover {\r\n  background: #e5e7eb;\r\n}\r\n\r\n/* ── Map wrapper for hub legend overlay ── */\r\n.map-google-wrap {\r\n  position: relative;\r\n}\r\n\r\n/* ── Sport Hubs legend ── */\r\n.hub-legend {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  left: 20px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.18);\r\n  max-width: 200px;\r\n  font-size: 12px;\r\n  z-index: 10;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.hub-legend-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.hub-legend-title {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  color: #374151;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.hub-legend-toggle {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 0.6rem;\r\n  color: #9ca3af;\r\n  padding: 2px 4px;\r\n  line-height: 1;\r\n}\r\n.hub-legend-toggle:hover { color: #374151; }\r\n\r\n.hub-legend-body {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  overflow-y: auto;\r\n  max-height: 360px;\r\n}\r\n\r\n.hub-legend-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.hub-legend-section-title {\r\n  font-size: 0.67rem;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.hub-legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.hub-legend-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  border: 1.5px solid rgba(255,255,255,0.8);\r\n  box-shadow: 0 0 0 1px rgba(0,0,0,0.10);\r\n}\r\n\r\n.hub-legend-name {\r\n  font-size: 0.74rem;\r\n  color: #374151;\r\n  line-height: 1.2;\r\n}\r\n\r\n.hub-legend-scale {\r\n  border-top: 1px solid #e5e7eb;\r\n  padding-top: 8px;\r\n}\r\n\r\n.hub-scale-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.hub-scale-dot {\r\n  border-radius: 50%;\r\n  background: #6b7280;\r\n  flex-shrink: 0;\r\n  display: inline-block;\r\n}\r\n\r\n.hub-scale-label {\r\n  font-size: 0.67rem;\r\n  color: #9ca3af;\r\n  margin-left: 2px;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.explore-map-placeholder {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n}\r\n\r\n.explore-map-placeholder p {\r\n  background: rgba(0,0,0,0.72);\r\n  color: white;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.01em;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.3);\r\n}\r\n\r\n/* ── Compare Mode ──────────────────────────────────────── */\r\n.compare-mode {\r\n  flex: 1;\r\n  max-width: 1200px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 24px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.compare-header h2 { color: white; margin-bottom: 6px; }\r\n.compare-description { color: rgba(255,255,255,0.85); font-size: 0.95rem; }\r\n\r\n.compare-pickers {\r\n  display: flex;\r\n  gap: 24px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.compare-vs {\r\n  color: white;\r\n  font-size: 1.4rem;\r\n  font-weight: 700;\r\n  padding-top: 48px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.region-picker {\r\n  flex: 1;\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.region-picker h3 { color: #333; }\r\n\r\n.region-type-toggle { display: flex; gap: 8px; }\r\n\r\n.region-type-toggle button {\r\n  flex: 1;\r\n  padding: 7px;\r\n  border: 2px solid #ddd;\r\n  border-radius: 6px;\r\n  background: white;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.region-type-toggle button.active {\r\n  border-color: #667eea;\r\n  background: #667eea;\r\n  color: white;\r\n}\r\n\r\n.compare-input {\r\n  width: 100%;\r\n  padding: 9px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.compare-input:focus { outline: none; border-color: #667eea; }\r\n\r\n.compare-select {\r\n  width: 100%;\r\n  padding: 9px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.compare-actions { display: flex; justify-content: center; }\r\n\r\n.compare-btn {\r\n  padding: 12px 40px;\r\n  background: white;\r\n  color: #667eea;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\r\n}\r\n\r\n.compare-btn:hover:not(:disabled) { background: #f0f0ff; transform: translateY(-1px); }\r\n.compare-btn:disabled { opacity: 0.5; cursor: not-allowed; }\r\n\r\n.compare-error { color: #fca5a5; text-align: center; font-size: 0.95rem; }\r\n\r\n.compare-results {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.compare-totals { display: flex; gap: 16px; }\r\n\r\n.compare-total-card {\r\n  flex: 1;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.compare-total-label { font-size: 0.9rem; opacity: 0.85; margin-bottom: 4px; }\r\n.compare-total-num { font-size: 1.6rem; font-weight: 700; }\r\n\r\n.compare-chart-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.compare-chart-title { color: #333; font-size: 1.1rem; margin: 0; }\r\n.compare-chart-note { color: #888; font-size: 0.82rem; margin-bottom: 12px; }\r\n\r\n.compare-top-n {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.85rem;\r\n  color: #555;\r\n}\r\n\r\n.compare-top-n select {\r\n  padding: 3px 8px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 0.85rem;\r\n  background: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.compare-tables { display: flex; gap: 20px; }\r\n\r\n.compare-table-wrap { flex: 1; }\r\n.compare-table-wrap h4 { color: #333; margin-bottom: 8px; }\r\n\r\n.compare-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.compare-table th, .compare-table td {\r\n  padding: 7px 10px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.compare-table th { color: #666; font-weight: 600; background: #f9f9f9; }\r\n.compare-table td { color: #333; }\r\n\r\n/* ── 响应式设计 */\r\n@media (max-width: 1024px) {\r\n  .app-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .app-sidebar {\r\n    width: 100%;\r\n  }\r\n\r\n  .app-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .app-header h1 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .app-header p {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .modal-content {\r\n    max-width: 90vw;\r\n    max-height: 90vh;\r\n  }\r\n\r\n  .search-results {\r\n    max-height: 200px;\r\n  }\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════════\r\n   Agent QA chat component\r\n   ══════════════════════════════════════════════════════════ */\r\n.agent-qa {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n  overflow: hidden;\r\n  flex: 1;\r\n  min-height: 520px;\r\n}\r\n\r\n.agent-header {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  padding: 18px 24px 14px;\r\n  color: white;\r\n}\r\n\r\n.agent-header-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.agent-header h2 { font-size: 1.2rem; margin-bottom: 4px; }\r\n\r\n.agent-desc { font-size: 0.83rem; opacity: 0.85; line-height: 1.4; }\r\n\r\n.agent-clear-btn {\r\n  background: rgba(255,255,255,0.2);\r\n  border: 1px solid rgba(255,255,255,0.4);\r\n  color: white;\r\n  border-radius: 20px;\r\n  padding: 4px 14px;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  transition: background 0.15s;\r\n}\r\n.agent-clear-btn:hover { background: rgba(255,255,255,0.3); }\r\n\r\n/* Scrollable conversation area */\r\n.agent-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  min-height: 0;\r\n}\r\n\r\n/* Suggested questions */\r\n.agent-suggestions { display: flex; flex-direction: column; gap: 10px; padding: 12px 0; }\r\n.agent-suggestions-label { font-size: 0.85rem; color: #888; font-weight: 500; }\r\n.agent-suggestions-grid { display: flex; flex-direction: column; gap: 8px; }\r\n\r\n.agent-suggestion-btn {\r\n  background: #f0f0fd;\r\n  border: 1px solid #d0d0f5;\r\n  border-radius: 8px;\r\n  padding: 10px 14px;\r\n  text-align: left;\r\n  font-size: 0.88rem;\r\n  color: #4c4ce0;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n  font-family: inherit;\r\n}\r\n.agent-suggestion-btn:hover { background: #e3e3fa; }\r\n\r\n/* Message rows */\r\n.agent-msg {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 85%;\r\n}\r\n.agent-msg--user { align-self: flex-end; align-items: flex-end; }\r\n.agent-msg--agent { align-self: flex-start; align-items: flex-start; max-width: 92%; }\r\n\r\n/* Bubbles */\r\n.agent-bubble {\r\n  border-radius: 12px;\r\n  padding: 10px 14px;\r\n  line-height: 1.55;\r\n  font-size: 0.9rem;\r\n}\r\n.agent-msg--user .agent-bubble {\r\n  background: #667eea;\r\n  color: white;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n.agent-msg--agent .agent-bubble {\r\n  background: #f5f5f5;\r\n  color: #333;\r\n  border-bottom-left-radius: 4px;\r\n  white-space: pre-wrap;\r\n}\r\n.agent-bubble--loading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n/* Spinner */\r\n.agent-spinner {\r\n  display: inline-block;\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 2px solid #ddd;\r\n  border-top-color: #667eea;\r\n  border-radius: 50%;\r\n  animation: agent-spin 0.8s linear infinite;\r\n  flex-shrink: 0;\r\n}\r\n@keyframes agent-spin { to { transform: rotate(360deg); } }\r\n\r\n/* Bubble footer (sources + copy) */\r\n.agent-bubble-footer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.agent-sources { font-size: 0.75rem; color: #888; line-height: 1.4; }\r\n.agent-sources-label { font-weight: 600; color: #999; }\r\n\r\n.agent-copy-btn {\r\n  background: none;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 2px 8px;\r\n  font-size: 0.75rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  align-self: flex-start;\r\n  font-family: inherit;\r\n}\r\n.agent-copy-btn:hover { background: #f0f0f0; }\r\n\r\n.agent-ts { font-size: 0.72rem; color: #bbb; margin-top: 3px; }\r\n\r\n/* Error row */\r\n.agent-error-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 14px;\r\n  background: #fff3f3;\r\n  border: 1px solid #fca5a5;\r\n  border-radius: 8px;\r\n  font-size: 0.88rem;\r\n}\r\n.agent-error-text { color: #dc2626; flex: 1; }\r\n.agent-retry-btn {\r\n  background: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 4px 12px;\r\n  font-size: 0.82rem;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n}\r\n.agent-retry-btn:hover { background: #b91c1c; }\r\n\r\n/* Input form */\r\n.agent-form {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 12px 16px;\r\n  border-top: 1px solid #eee;\r\n  background: white;\r\n}\r\n\r\n.agent-input {\r\n  flex: 1;\r\n  padding: 9px 14px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 24px;\r\n  font-size: 0.9rem;\r\n  outline: none;\r\n  font-family: inherit;\r\n}\r\n.agent-input:focus { border-color: #667eea; }\r\n.agent-input:disabled { background: #f5f5f5; }\r\n\r\n.agent-send-btn {\r\n  background: #667eea;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 24px;\r\n  padding: 9px 20px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  flex-shrink: 0;\r\n  font-family: inherit;\r\n}\r\n\r\n/* ── Sport Finder ────────────────────────────────────────── */\r\n.sport-finder-card-wrap {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  margin-top: 0;\r\n}\r\n\r\n.sport-finder-title {\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.sport-finder-subtitle {\r\n  font-size: 0.85rem;\r\n  color: #6b7280;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.sport-finder-inputs {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.sport-finder-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1 1 140px;\r\n}\r\n\r\n.sport-finder-field span {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: #374151;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.sport-finder-field input {\r\n  padding: 7px 10px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  font-size: 0.9rem;\r\n  color: #111827;\r\n  background: #f9fafb;\r\n  transition: border-color 0.15s;\r\n  outline: none;\r\n}\r\n\r\n.sport-finder-field input:focus {\r\n  border-color: #667eea;\r\n  background: white;\r\n}\r\n\r\n.sport-finder-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 9px 22px;\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 0.92rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s;\r\n  font-family: inherit;\r\n}\r\n\r\n.sport-finder-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.sport-finder-btn:not(:disabled):hover {\r\n  opacity: 0.88;\r\n}\r\n\r\n.sport-finder-error {\r\n  margin-top: 10px;\r\n  color: #dc2626;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.sport-finder-results {\r\n  margin-top: 16px;\r\n}\r\n\r\n.sport-finder-results h4 {\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.sport-finder-cards {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sport-finder-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  padding: 12px 16px;\r\n  background: linear-gradient(135deg, #f0f4ff, #faf5ff);\r\n  border: 1px solid #c7d2fe;\r\n  border-radius: 10px;\r\n  min-width: 160px;\r\n  flex: 1 1 160px;\r\n}\r\n\r\n.sport-finder-rank {\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  color: #764ba2;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.sport-finder-sport {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #1f2937;\r\n}\r\n\r\n.sport-finder-freq {\r\n  font-size: 0.78rem;\r\n  color: #6b7280;\r\n}\r\n.agent-send-btn:hover:not(:disabled) { background: #5a6fd6; }\r\n.agent-send-btn:disabled { background: #ccc; cursor: not-allowed; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
